module.exports = __webpack_public_path__ + "static/media/newyork_panorama.5c76200c.jpg";